/**
 * Ordena filas de planificación según la lista de IDs de empleados del grupo.
 * Empleados sin posición explícita se mantienen al final, conservando su orden relativo.
 */
export function sortPlanAssignmentsByEmployeeIds(assignments, employeeIds) {
	if (!Array.isArray(assignments) || assignments.length === 0) {
		return assignments || [];
	}
	if (!Array.isArray(employeeIds) || employeeIds.length === 0) {
		return assignments;
	}

	const orderMap = new Map(employeeIds.map((id, index) => [id, index]));

	return [...assignments].sort((a, b) => {
		const orderA = orderMap.get(a?.employee?.id);
		const orderB = orderMap.get(b?.employee?.id);
		const aKnown = typeof orderA === "number";
		const bKnown = typeof orderB === "number";

		if (aKnown && bKnown) return orderA - orderB;
		if (aKnown) return -1;
		if (bKnown) return 1;
		return 0;
	});
}

const employeeKey = (employee) => {
	if (employee?.id == null) return null;
	return String(employee.id);
};

/**
 * Reordena los contadores para que coincidan 1:1 con las filas del plan.
 * El API de accounts/assignments no respeta el orden del grupo; pintar por
 * índice desplaza Horas efectivas (p. ej. 0 de otro empleado sobre MISERICORDIA).
 */
export function alignAccountAssignmentsToPlan(
	accountAssignments,
	planAssignments
) {
	if (!Array.isArray(planAssignments) || planAssignments.length === 0) {
		return accountAssignments || [];
	}
	if (!Array.isArray(accountAssignments) || accountAssignments.length === 0) {
		return accountAssignments || [];
	}

	const byEmployeeId = new Map();
	accountAssignments.forEach((assignment) => {
		const key = employeeKey(assignment?.employee);
		if (key == null || byEmployeeId.has(key)) return;
		byEmployeeId.set(key, assignment);
	});

	const templateCounters = accountAssignments[0]?.counters || [];

	return planAssignments.map((planAssignment) => {
		const key = employeeKey(planAssignment?.employee);
		const found = key != null ? byEmployeeId.get(key) : undefined;
		if (found) return found;

		return {
			employee: planAssignment?.employee,
			counters: templateCounters.map((counter) => ({
				...counter,
				value: 0,
			})),
		};
	});
}
